import { Textarea } from "@xola/ui-kit";
import clsx from "clsx";
import { useField } from "formik";
import React, { ComponentProps, useContext } from "react";
import { FormFieldContext, useError } from "./FormField";

interface TextareaFieldProps extends ComponentProps<"textarea"> {
    isRequired?: boolean;
    shouldAutoSize?: boolean;
}

export const TextareaField = (props: TextareaFieldProps) => {
    const name = useContext(FormFieldContext) ?? props.name;
    const [field, _, helpers] = useField(name);
    const error = useError(name);
    const className = clsx(props.className, "leading-4.5");
    const value = field?.value ?? props.value ?? "";
    const shouldAutoSize = props.shouldAutoSize;
    return (
        <Textarea
            isError={!!error}
            shouldAutoSize={shouldAutoSize}
            {...field}
            {...props}
            onChange={(e: any) => {
                if (props.onChange) {
                    props.onChange(e);
                }

                helpers.setValue(e.target.value);
            }}
            value={value}
            className={className}
        />
    );
};
